import { Pipe, PipeTransform } from '@angular/core';

/**
 * 將YYYYMMDD格式的日期轉換為YYYY年MM月DD日格式的管道
 * ex. 20250101 轉換為 2025年01月01日
 */
@Pipe({
  name: 'formatDate',
  standalone: true,
})
export class FormatDatePipe implements PipeTransform {
  transform(value: string): string {
    if (!/^\d{8}$/.test(value)) {
      return value;
    }
    const year = value.substring(0, 4);
    const month = value.substring(4, 6);
    const day = value.substring(6, 8);
    return `${year}年${month}月${day}日`;
  }
}
